(function () {
  function animateItem(el, duration) {
    var target = parseInt(el.dataset.targetPercentage, 10) || 0;
    var numberEl = el.querySelector('.results__percentage-number');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      el.style.setProperty('--percentage', target + '%');
      if (numberEl) numberEl.textContent = target;
      return;
    }

    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);

      el.style.setProperty('--percentage', current + '%');
      if (numberEl) numberEl.textContent = current;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function init() {
    var items = document.querySelectorAll('.results__percentage[data-target-percentage]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        animateItem(el, 1200);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateItem(entry.target, 1200);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
